import List from 'src/storage/list';
import AlertManager from 'src/components/alert/AlertManager';
import LANG_CONST from 'src/helpers/lang/const';

class AdminVisitCardOrderModel extends List {
  id = 'AdminVisitCardOrderModel';
  defaultState = () => ({
    current: 'recent',
    total: 0,
    pageIndex: 0,
    sortBy: {
      sortKey: 'date',
      desc: true
    }
  });

  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;

  apiConfig = {
    refresh: {
      url: 'admin/visitCardOrder/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'admin/visitCardOrder/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'admin/visitCardOrder/list',
      validation: {
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    update: {
      url: 'admin/visitCardOrder/update',
      validation: {},
      cancellable: true
    },
    status: {
      url: 'admin/visitCardOrder/status',
      validation: {},
      cancellable: true
    },
    remove: {
      url: 'admin/visitCardOrder/remove',
      validation: {},
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy
    };
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  updateStatus(item, status, cb) {
    this.api('status', { id: item.id, status }, (err, data) => {
      if (!err) {
        item.status = status;
        this.trigger();
      }
      cb && cb(err, data);
    });
  }

  remove(item, cb) {
    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);

          this.api('remove', { id: item.id }, (err, data) => {
            if (!err) {
              this.removeItem(item.id);
            }
            actions.setLoading(false);
            actions.hide();
            cb && cb(err, data);
          });
        }
      }
    });
  }
  logAsDoctor = (item) => {
    this.emit('login_as_other_user', { id: item.id });
  };
}

const model = new AdminVisitCardOrderModel();
export default model;
